import script from "./CalculationAssemblySection.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculationAssemblySection.vue?vue&type=script&setup=true&lang=js"

import "./CalculationAssemblySection.vue?vue&type=style&index=0&id=230ca8b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230ca8b4"]])

export default __exports__